import {Flex} from '@priority-software/priority-style-react';
import React from 'react';
import texts from '../../../texts';
import styles from '../../../styles.module.scss';
import AxisSelector from './AxisSelector';
import {bubbleConfigInfo, chartConfigInfo} from '../../../consts';
import AxisInput from './AxisInput';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';
import GaugeScalesSelector from './GaugeScalesSelector';
import {getXAxisPlaceHolderByType} from '../../../utils';

const XAxisSection = ({columns, chartInfo, updateChartConfig, xAsCategory}) => {
    const {isBubble, isGauge, isKpi} = reportGeneratorsStore?.currentScreen;

    const minX = chartInfo.bubbleConfig?.[bubbleConfigInfo.minX];
    const maxX = chartInfo.bubbleConfig?.[bubbleConfigInfo.maxX];
    const isError = minX && maxX && Number(minX) > Number(maxX);

    return (
        <Flex direction="row" justifyContent="flex-start">
            {!isGauge && !isKpi && (
                <AxisSelector
                    axisName={chartInfo.xAxis?.Title || ''}
                    title={xAsCategory ? texts.xAxisCategory : texts.xAxis}
                    options={columns}
                    onSelect={e => updateChartConfig(chartConfigInfo.xAxis, e)}
                    helpText={texts.xAxisHelp}
                    placeholder={getXAxisPlaceHolderByType(chartInfo.type)}
                />
            )}
            {isGauge && (
                <GaugeScalesSelector
                    axisName={chartInfo?.scales?.fieldsMap[0][1].currentValue || ''}
                    title={texts.scale}
                    onSelect={e => updateChartConfig(chartConfigInfo.scales, e)}
                    helpText={texts.gaugeRange}
                />
            )}
            {isBubble && (
                <AxisInput
                    title={texts.minimumX}
                    value={minX || ''}
                    onChange={e => updateChartConfig(bubbleConfigInfo.minX, e.target.value)}
                    compClass={styles.bubbleInp}
                    helpText={texts.minAxisValue}
                    placeholder={texts.bubbleXAxisStartRange}
                    maxLength={10}
                    isError={isError}
                />
            )}
            {isBubble && (
                <AxisInput
                    title={texts.maximumX}
                    value={maxX || ''}
                    onChange={e => updateChartConfig(bubbleConfigInfo.maxX, e.target.value)}
                    compClass={null}
                    helpText={texts.maxAxisValue}
                    placeholder={texts.bubbleXAxisEndRange}
                    maxLength={10}
                />
            )}
        </Flex>
    );
};

export default XAxisSection;
